module.exports = __webpack_public_path__ + "img/icon_calendar.c271f630.svg";